export default __webpack_public_path__ + "static/media/image_1.c779a7a2.png";